import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { KpiAnalyticsModel } from '../../../services-api-v2/kpi-follow-up/models/kpi-analytics.model';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';
// TODO: Remove after testing processes functionality on kpi module
// import { ProcessEventsAndTClassBlocksModel } from '../../../services-api-v2/kpi-follow-up/models/process-events-and-t-class-blocks.model';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-kpi-processes-list-table',
    templateUrl: './kpi-processes-list-table.component.html',
    styleUrls: ['./kpi-processes-list-table.component.scss', '../../../../../assets/styles/kpi-styles/kpi-table-styles.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KpiProcessesListTableComponent implements OnChanges {

  @Input() processes: KpiAnalyticsModel[];
  @Input() showActions = false;
  // TODO: Remove after testing processes functionality on kpi module
  // @Input() plannedEventsAndTClassBlocks: ProcessEventsAndTClassBlocksModel;
  // @Input() isProcessUnassigning: boolean;
  // @Input() displayActionColumn: boolean;

  @ViewChild('periodBasedTable', {static: false}) periodBasedTable: MatTable<any>;

  @Output() tableDataToExport: EventEmitter<any> = new EventEmitter<any>();
  // TODO: Remove after testing processes functionality on kpi module
  // @Output() expandedElementChange: EventEmitter<KpiAnalyticsModel> = new EventEmitter<KpiAnalyticsModel>();
  @Output() selectProcess: EventEmitter<any> = new EventEmitter<any>();
  @Output() editProcess: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteProcess: EventEmitter<any> = new EventEmitter<any>();

  // TODO: Remove after testing processes functionality on kpi module
  // @Output() optionSelectedBlocks: EventEmitter<any> = new EventEmitter();
  // @Output() optionSelectedEvents: EventEmitter<any> = new EventEmitter();

  public dataSource: MatTableDataSource<KpiAnalyticsModel> = new MatTableDataSource();
  public columnsToDisplay = ['name', 'parksTitle', 'estimatedStartEnd', 'durationPlanned', 'durationRealized', 'durationDeviation', 'productionLossRealized', 'revenueLossRealized', 'action'];
  public columnsToTranslate = [
    'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.PROCESS',
    'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.ASSET',
    'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.ESTIMATED_START_END',
    'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.DURATION_PLANNED',
    'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.DURATION_REALIZED',
    'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.DURATION_DEVIATION',
    'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.PROD_LOSS_REALIZED',
    'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.REV_LOSS_REALIZED',
    ''
  ];
  // TODO: Remove after testing processes functionality on kpi module
  // public expandedElement = null;
  // public selectedTabIndex = 0;
  public optionsSelect = ['BUTTONS.EDIT', 'BUTTONS.DELETE'];

  public translateService = inject(TranslateService);

  protected calculateTotal(processes: KpiAnalyticsModel[]): KpiAnalyticsModel[] {
    return processes.reduce((acc: any, process: KpiAnalyticsModel) => {
      return {
        ...acc,
        durationPlanned: (acc.durationPlanned ? acc.durationPlanned : 0) + process.durationPlanned,
        durationRealized: (acc.durationRealized ? acc.durationRealized : 0) + process.durationRealized,
        durationDeviation: (acc.durationDeviation ? acc.durationDeviation : 0) + process.durationRealized - process.durationPlanned,
        productionLossRealized: (acc.productionLossRealized ? acc.productionLossRealized : 0) + process.productionLossRealized,
        revenueLossRealized: (acc.revenueLossRealized ? acc.revenueLossRealized : 0) + process.revenueLossRealized,
        color: 'transparent',
        id: null,
        name: 'TOTAL',
        total: true
      };
    }, {});
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.processes?.currentValue) {
      const processes = changes.processes.currentValue;
      const total = processes.length > 0 ? this.calculateTotal(processes) : null;
      this.dataSource = new MatTableDataSource(total ? [...processes, total] : processes);
      this.exportTableData();
    }
  }

  // TODO: Remove after testing processes functionality on kpi module
  // public expandedElementClicked(event: KpiAnalyticsModel): void {
  //   if (!event || this.expandedElement !== event) {
  //     this.selectedTabIndex = 0;
  //   }
  //   this.expandedElement = this.expandedElement === event ? null : event;
  //   this.expandedElementChange.emit(event);
  // }

  public selectItem(item: any) {
    if (!item.total) {
      this.selectProcess.emit(item);
    }
  }

  public editItem(item: any) {
    this.editProcess.emit(item);
  }

  public deleteItem(item: any) {
    this.deleteProcess.emit(item);
  }

  public selectOption(event: { index: number, option: string }, element: any): void {
    if (event.option === 'BUTTONS.EDIT') {
      this.editProcess.emit(element);
    } else if (event.option === 'BUTTONS.DELETE') {
      this.deleteProcess.emit(element);
    }
  }

  // TODO: Remove after testing processes functionality on kpi module
  // public optionSelectedBlocksFunc(option: any) {
  //   this.optionSelectedBlocks.emit(option);
  // }

  // public optionSelectedEventsFunc(option: any) {
  //   this.optionSelectedEvents.emit(option);
  // }

  private exportTableData(): void {
    const int = interval(50).pipe(
      take(100)
    ).subscribe(() => {
      // @ts-ignore
      if (this.periodBasedTable?._elementRef) {
        // @ts-ignore
        this.tableDataToExport.emit(this.periodBasedTable._elementRef.nativeElement);
        int.unsubscribe();
      }
    });
  }

}
